export default "__VITE_ASSET__76522a6c__"